import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { H4 } from 'foundations-components/transitional/components/H4';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function DeletedViewEmptyState() {
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "center",
    blockSize: "400px",
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email-management.emptyState.deletedView.title"
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email-management.emptyState.deletedView.body"
      })]
    }), /*#__PURE__*/_jsx(Illustration, {
      name: "empty-state-charts",
      marginInlineStart: "1700"
    })]
  });
}